import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-location',
	templateUrl: './location.component.html',
	styleUrls: ['./location.component.css'],
})
export class LocationComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/location/';
	protected parentComponent = 'location';
	locations = [];
	pageTitle = 'Lokalizacje -> Dodawanie';
	pageFunction = 'edit';
	optionalTrip: Array<any> = [];
	locationsKinds: Array<any> = [
		{ value: 'CR', name: 'Państwo' },
		{ value: 'RG', name: 'Region' },
		{ value: 'CT', name: 'Miasto' },
	];

	protected holdMultimedia;
	protected holdOptionalTrip;
	checkSubmit = false;

	data = {
		id: null,
		name: null,
		code: null,
		locationKind: null,
		multimedia: [],
		parentLocation: null,
		locationDescriptions: [],
		locationOptionalTrips: [],
	};

	protected pageTitleGenerate(): string {
		return `Lokalizacje ->
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	protected checkForms() {
		if (this.pageFunction == 'add') {
			delete this.data.id;
			if (
				this.locations.find((item) => item.name == this.data.name && item.code == this.data.code) != undefined
			) {
				this.infobox.error('Taka lokalizacja już istnieje!');
				return;
			}
		}
		if (this.data.name === '') {
			this.infobox.error(`Nazwa nie może być pusta!`);
			return;
		}
		if (this.data.code === '' && this.data.locationKind == 'CR') {
			this.infobox.error(`Kod nie może być pusty, gdy rodzaj lokalicacji to Państwo!`);
			return;
		}
		this.submit();
	}

	protected submitBefore(): void {
		this.apiUrl = this.getApiUrl();
		this.holdOptionalTrip = this.data.locationOptionalTrips;
		this.data.locationOptionalTrips = this.data.locationOptionalTrips.map((item, index) => {
			return {
				id: item.id,
				optionalTrip: item.optionalTrip.id,
				order: index,
			};
		});

		this.holdMultimedia = this.data.multimedia;
		this.data.multimedia = this.data.multimedia.map((item, index) => {
			return {
				id: item.id,
				multimedia: item.multimedia.id,
				order: index,
			};
		});
		this.data.locationDescriptions = this.data.locationDescriptions.map((item) => {
			return {
				id: item.id,
				descriptionHeader: item.descriptionHeader,
				description: item.description,
			};
		});
	}

	protected convertData(data: any) {
		if (data.multimedia != undefined) {
			data.multimedia.forEach((obj, index) => {
				obj.order = index + 1;
			});
		}

		return data;
	}

	protected submitAfter(): void {
		if (this.checkSubmit == true) {
			this.data.multimedia = this.holdMultimedia;
			this.data.locationOptionalTrips = this.holdOptionalTrip;
		} else {
			this.router.navigate([this.parentComponent]);
		}
	}

	protected submitAndStay() {
		this.checkSubmit = true;
		this.checkForms();
	}

	protected submitAndExit() {
		this.checkSubmit = false;
		this.checkForms();
	}

	protected loadBefore(): void {
		this.bag.get('/location/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.locations = result.results;
		});

		this.bag.get('/optional_trip/?limit=9999', (result, error) => {
			this.optionalTrip = result.results;
			this.optionalTrip.map((item) => {
				item.isActive = item.isActive ? 'tak' : 'nie';
				this.data.locationOptionalTrips.map((el) => {
					if (item.id == el.optionalTrip) {
						el.optionalTrip = item;
					}
				});
			});
		});
		this.loadData();
	}

	protected getApiUrl(): string {
		return '/location/' + this.data.id + '/';
	}
}
